import { useTokenData, useTranslation } from "@onefront/react-sdk";
import Box from "@vapor/react-material/Box";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";

export const WelcomeMSG = () => {
  const tokenData = useTokenData();
  const { t } = useTranslation();

  return (
    <Box>
      <ExtendedTypography variant="text">
        {t("welcome_user", { name: tokenData?.name })}
      </ExtendedTypography>
    </Box>
  );
};
